type Props = {
  pos?: Array<number>;
};
export default function Torus({ pos = [0, 0, 0] }: Props) {
  return (
    <mesh position={[pos[0], pos[1], pos[2]]}>
      <torusGeometry args={[0.15, 0.02, 20, 50]} />
      <meshPhysicalMaterial color='#E49E1D' roughness={0} metalness={1} />
    </mesh>
  );
}
